
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psicopedagogia",
      function () {
        return require("private-next-pages/psicopedagogia/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/psicopedagogia"])
      });
    }
  